import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__radix_ui_react_collapsible_4615ddd5__ from "@radix-ui/react-collapsible";
function Collapsible({ ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_collapsible_4615ddd5__.Root, {
        "data-slot": "collapsible",
        ...props
    });
}
function CollapsibleTrigger({ ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_collapsible_4615ddd5__.CollapsibleTrigger, {
        "data-slot": "collapsible-trigger",
        ...props
    });
}
function CollapsibleContent({ ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_collapsible_4615ddd5__.CollapsibleContent, {
        "data-slot": "collapsible-content",
        ...props
    });
}
export { Collapsible, CollapsibleContent, CollapsibleTrigger };
